import { PLATFORMS_WITH_CONVERSION_TYPES } from './conversion-types/conversion-types-select/conversion-types-select.constants';

export const shouldShowConversionTypes = platform => PLATFORMS_WITH_CONVERSION_TYPES
    .includes(platform);
